import { ReactNode } from "react";

import Button from "./Button";
import Modal from "./Modal";

interface AlertModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  icon?: ReactNode;
  confirmText?: string;
  children?: ReactNode;
}

const AlertModal = ({
  show,
  onClose,
  title,
  icon,
  confirmText = "OK",
  children
}: AlertModalProps) => {
  const actions = (
    <Button onClick={onClose} variant="primary">
      {confirmText}
    </Button>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      icon={icon}
      actions={actions}
    >
      {children}
    </Modal>
  );
};

export default AlertModal; 